module.exports = __webpack_public_path__ + "img/5-4.c0959d7a.svg";